import createAction from './createAction';

// because icepick is implemented using commonjs modules,
// which we don't suppport, it has to be required in this way
const icepick = require('../../../node_modules/icepick/icepick.min');

// 1. Initial state
const initialState = icepick.freeze({
  pageList: []
});

// 2. Actions
const SET_PAGINATION_PAGE_LIST = 'listingPage/pagination/SET_PAGINATION_PAGE_LIST';
const SET_PAGINATION_ITEMS_NUMBER_PER_PAGE =
  'listingPage/pagination/SET_PAGINATION_ITEMS_NUMBER_PER_PAGE';
const SET_CURRENT_PAGINATOR_PAGE = 'listingPage/pagination/SET_CURRENT_PAGINATOR_PAGE';
const SET_PAGINATION_RESULTS_MESSAGE = 'listingPage/pagination/SET_PAGINATION_RESULTS_MESSAGE';
const SET_CATEGORY_PRODUCT_COUNT = 'listingPage/pagination/SET_CATEGORY_PRODUCT_COUNT';

// 3. Action creators
export function setPaginationPageList(pageList) {
  return createAction(SET_PAGINATION_PAGE_LIST)(pageList);
}

export function setPaginationItemsNumberPerPage(itemsNumberPerPage) {
  return createAction(SET_PAGINATION_ITEMS_NUMBER_PER_PAGE)(itemsNumberPerPage);
}

export function setCategoryProductCount(productCount) {
  return createAction(SET_CATEGORY_PRODUCT_COUNT)(productCount);
}

export function setCurrentPaginatorPage(pageNumber) {
  return createAction(SET_CURRENT_PAGINATOR_PAGE)(pageNumber);
}

export function setPaginationResultsMessage(message) {
  return createAction(SET_PAGINATION_RESULTS_MESSAGE)(message);
}

// 4. Reducer
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_PAGINATION_PAGE_LIST: {
      return icepick.setIn(state, ['pageList'], action.payload);
    }
    case SET_PAGINATION_ITEMS_NUMBER_PER_PAGE: {
      return icepick.setIn(state, ['itemsNumberPerPage'], action.payload);
    }
    case SET_CATEGORY_PRODUCT_COUNT: {
      return icepick.setIn(state, ['itemsNumberPerPage', 'categoryProductCount'], action.payload);
    }
    case SET_CURRENT_PAGINATOR_PAGE: {
      return icepick.updateIn(state, ['pageList'], (pageList) => icepick.map((page) => (
        icepick.setIn(page, ['isCurrent'], page.label === action.payload)
      ), pageList));
    }
    case SET_PAGINATION_RESULTS_MESSAGE: {
      return icepick.setIn(state, ['showingResultsLabel'], action.payload);
    }
    default: {
      return state;
    }
  }
}
